import { CustomSelectProps } from "@/common/types";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useEffect, useState } from "react";

const CustomSelect = ({
  options,
  onChange,
  placeholder,
  labelKey,
  valueKey,
  value,
}: CustomSelectProps) => {
  const [selectedValue, setSelectedValue] = useState<any | null>(value);

  useEffect(() => {
    const selected = options.find((option) => option[valueKey] === value);
    setSelectedValue(selected);
  }, [value]);

  return (
    <Select
      value={selectedValue?.[valueKey] || ""}
      onValueChange={(value) => {
        const selected = options.find((option) => option[valueKey] === value);
        setSelectedValue(selected);
        onChange(selected);
      }}
    >
      <SelectTrigger className="w-full border-black outline-none focus:outline-none focus:ring-0">
        <SelectValue placeholder={`Select ${placeholder || ""}...`} />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem key={option[valueKey]} value={option[valueKey]}>
            {option[labelKey]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default CustomSelect;
